import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.Boolean
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface FlightStatusControllerTargetLifecycleHooks {
  public fun statusTargetConnected(element: HTMLElement) {
  }

  public fun statusTargetDisconnected(element: HTMLElement) {
  }

  public fun statusUrlValueChanged(`value`: String, previousValue: String) {
  }
}

public fun <T : HTMLElement> FlightStatusController.statusTarget(): StimulusProperty<T> =
    StimulusProperty("statusTarget")

public fun <T : HTMLElement> FlightStatusController.statusTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("statusTargets")

public fun FlightStatusController.statusUrlValue(): StimulusProperty<String> =
    StimulusProperty("statusUrlValue")

public fun FlightStatusController.hasStatusUrlValue(): Boolean {
  println(this.asDynamic()["hasStatusUrlValue"])
  return this.asDynamic()["hasStatusUrlValue"]
}

public fun registerFlightStatusController(stimulus: Application) {
   val clazz = FlightStatusController::class
   val properties = object  {
      // Js name needed otherwise Kotlin will mangle the name
      @JsName("targets")
      val targets = js("['status']")

      @JsName("values")
      val values = buildValues(
          setOf(
              ValueDefinition("statusUrl", "String", false)
          ),
          FlightStatusController.Values
      )
      
      
      
      @JsName("classes")
      val classes = js("[]")
  }

  val factoryFunc = clazz.js.asDynamic()

  addStaticMembersTo(factoryFunc, properties)
  val controllerName = "flightstatus"
  println("Registering controller flightstatus")

  stimulus.register(controllerName, factoryFunc)
}
